<template>
  <div>
    <h1>{{location}}</h1>
    <div v-if="table && table.length === 0">
      <p>
        No Data for selected period
      </p>
    </div>
    <div v-else-if="isLoading === true">
      <p>
        Loading...
      </p>
    </div>
    <div v-else-if="store.data[location] && store.data[location].error === true">
      <p>
        Server Error
      </p>
    </div>
    <div v-else-if="!isLoading && table && table.length !== 0">
      <!-- {{ Object.keys(table[0])}} -->
      <div v-if="!isPivotView">
        <BasicTableComponent 
          style="width: 400px;"
          :list="table" 
          :totals="store.totals(location)"
          tableClass="table2excel"
          :tableID="location"
          :formatters="{
            'date' : ['d', 'ddd MM/DD/YY'], 
            'approved_count' :  ['n', '0,0'],
            'refund_count' :  ['n', '0,0'],
            'count' :  ['n', '0,0'],
          }"
          :hideColumns="['group']"
          :columnOrder="['date', 'device_number']"
          :titles="{
            'card_type_key' : 'Card<br>Type',
            'device_number' : 'Device<br>Number',
            'amount' : 'Total<br>Amount',
            'count' : 'Total<br>Count',
            'approved_amount' : 'Approved',
            'approved_count' : 'Approved<br>Count',
            'refund_amount' : 'Refund',
            'refund_count' : 'Refund<br>Count',
          }"
        />
      </div>
      <div v-else>
        <BasicTableComponent 
          style="width: 400px;"
          :list="store.pivotData(location)" 
          :totals="store.pivotTotals(location)"
          tableClass="table2excel"
          :tableID="location"
          :formatters="{
            'date' : ['d', 'ddd MM/DD/YY'], 
            'Interac_#' :  ['n', '0,0'],
            'VISA_#' :  ['n', '0,0'],
            'M/C_#' :  ['n', '0,0'],
            'Amex_#' :  ['n', '0,0'],
            'Discovery_#' :  ['n', '0,0'],
          }"
          :titles="{
            'Interac_amount' : 'Interac', 
            'Interac_#' : 'Interac<br>Count', 
            'VISA_amount' : 'Visa', 
            'VISA_#' : 'Visa<br>Count', 
            'M/C_amount' : 'M/C', 
            'M/C_#' : 'M/C<br>Count', 
            'Amex_amount' : 'Amex', 
            'Amex_#' : 'Amex<br>Count', 
            'Discovery_amount' : 'Discovery', 
          }"
        />
    </div>
  </div>
    
    
  </div>
</template>

<script>
export default {
  name: 'POSTable',
  inject:['page'],
  props:['location', 'storeName', 'isPivotView'],
  methods:{
    
  },
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
    dateKey(){ return this.timestamps.dateKey},
    isLoading(){
      let result = this.store.data[this.location].isLoading;
      result = result || !this.store.data[this.location].pos;
      return result
    },
    table(){return this.store.data[this.location].pos}
  },
}
</script>